import {IComponent} from '../../../interfaces/Analytics/Analytics'
import {ColumnDef, createColumnHelper} from '@tanstack/react-table'
import {useIntl} from 'react-intl'
import TableLite from '../../DataTable/TableLite'
import {formatTimeByFrame, toRupiah} from '../../../functions/general'
import clsx from 'clsx'
interface IProps {
  component: IComponent
  usePagination?: boolean
}
const includesSome = (row: any, columnId: string, filterValue: any[]) => {
  if (!Array.isArray(filterValue)) return true
  if (filterValue.length===0) return true
  const cellValue = row.getValue(columnId)
  return filterValue.includes(cellValue)
}

export default function List({component, usePagination}: IProps) {
  const intl = useIntl()
  const columnHelper = createColumnHelper<any>()
  const mergedData: any[] = []
  let columns: ColumnDef<any, any>[] = []
  const transformData = () => {
    const records = component.dataCore
    const labels = records[0].data.map((item) => item.label)

    const tableData = records.map((row) => {
      const obj: Record<string, any> = {name: row.name.trim()}
      row.data.forEach((item) => {
        if (row.name === '% Actual to Target') {
          obj[item.label] = '% ' + item.value
          return
        }
        obj[item.label] = item.value
        return
      })
      return obj
    })

    return {tableData, labels}
  }
  if ((component.customCompany === null || component.customCompany === ''|| !component.customCompany||component.customCompany==="TRIPLA_PIC_MERCHANT") && component.formattedResult!=="FLIP") {
    columns.push(
      columnHelper.accessor('label', {
        header:component.customCompany==="TRIPLA_PIC_MERCHANT"? intl.formatMessage({id: 'MENU.USERS'}):component.outputType==="DATE"?intl.formatMessage({id: 'FORM.ACTION.DATE'}):intl.formatMessage({id: 'FORM.LABEL.NAME'}),
        size: 10,
        cell: (info) => (
          <span className='d-flex justify-content-between align-items-center gap-3'>
            <span>{component.customCompany==="TRIPLA_PIC_MERCHANT"||component.outputType!=="DATE"?info.getValue():formatTimeByFrame(info.getValue(), component.timeFrame)}</span>
          </span>
        ),
      })
    )
    component.dataCore.forEach((core) => {
      core.data.forEach((entry) => {
        let existing = mergedData.find((item) => item.label === entry.label)
        if (!existing) {
          existing = {label: entry.label}
          mergedData.push(existing)
        }
        existing[core.name] = entry.value
      })
    })
    component.dataCore.forEach((core) => {
      columns.push({
        header: core.name,
        accessorKey: core.name,
        size: 10,
        cell: (info) => (
          <span
            className={clsx(
              'd-flex  align-items-center gap-3 w-100 px-2',
              component.dataType === 'NOMINAL' ? 'justify-content-end ' : 'justify-content-center'
            )}
          >
            {component.dataType === 'NOMINAL' ? toRupiah(info.getValue()) : info.getValue()}
          </span>
        ),
      })
    })
  }
  if (
    component.customCompany === 'VEDA_TYPE_C' ||
    component.customCompany === 'VEDA_TYPE_B' ||
    component.customCompany === 'VEDA_TYPE_A' ||
    component.customCompany === 'VEDA_TYPE_D' ||
    component.formattedResult ==="FLIP"
  ) {
    const {tableData, labels} = transformData()
    tableData.forEach((data: any) => {
      mergedData.push(data)
    })
    columns.push(
     columnHelper.accessor('name', {
      header: '',
        size: 150,
      cell: (info) => info.getValue(),
        meta: {align: 'left'},
      filterFn: includesSome,
    }),
          ...labels.map((label) =>
        columnHelper.accessor(label, {
          meta: {align: 'right'},
          header: (component.formattedResult==="FLIP"&&component.outputType==="DATE")?formatTimeByFrame(label, component.timeFrame):label ,
          size: 150,
          cell: (info) => {
            const value = info.getValue()

            if (String(value).includes('%')) {
              return info.getValue()
            }
            return component.dataType === 'NOMINAL' ? toRupiah(info.getValue()) : info.getValue()
          },
          filterFn:includesSome
        })
      )
    )
  }
  return (
    <div className='px-4'>
      <TableLite
      stickyHeader={component.customCompany === 'VEDA_TYPE_D'}
        usePagination={usePagination}
        columns={columns}
        data={mergedData}
        enableColumnFilter={
          component.customCompany === 'VEDA_TYPE_C' ||
          component.customCompany === 'VEDA_TYPE_B' ||
          component.customCompany === 'VEDA_TYPE_A' ||
          component.customCompany === 'VEDA_TYPE_D'
        }
      />
    </div>
  )
}
